import { render, staticRenderFns } from "./M12_S17.vue?vue&type=template&id=54aa4560&scoped=true"
import script from "./M12_S17.vue?vue&type=script&lang=js"
export * from "./M12_S17.vue?vue&type=script&lang=js"
import style0 from "./M12_S17.vue?vue&type=style&index=0&id=54aa4560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aa4560",
  null
  
)

export default component.exports